import { useContext, useEffect, useState, useRef } from 'react';
import { isQueryPresent } from '@cubejs-client/core';

import CubeContext from '../CubeContext';
import useDeepCompareMemoize from './deep-compare-memoize';

export function useCubeFetch(method, options = {}) {
  const context = useContext(CubeContext);
  const mutexRef = useRef({});

  const [response, setResponse] = useState({
    isLoading: false,
    response: null,
  });
  const [error, setError] = useState(null);

  const { skip = false } = options;

  async function load(loadOptions = {}, ignoreSkip = false) {
    const cubeApi = options.cubeApi || context?.cubeApi;
    const query = loadOptions.query || options.query;

    const queryCondition =
      method === 'meta' ? true : query && isQueryPresent(query);

    if (cubeApi && (ignoreSkip || !skip) && queryCondition) {
      setError(null);
      setResponse({
        isLoading: true,
        response: null,
      });

      const coreOptions = {
        mutexObj: mutexRef.current,
        mutexKey: method,
        ...(options.baseRequestId ? { baseRequestId: options.baseRequestId } : {})
      };
      const args = method === 'meta' ? [coreOptions] : [query, coreOptions];

      try {
        const response = await cubeApi[method](...args);

        setResponse({
          response,
          isLoading: false,
        });
      } catch (error) {
        setError(error);
        setResponse({
          isLoading: false,
          response: null,
        });
      }
    }
  }

  useEffect(() => {
    load();
  }, useDeepCompareMemoize([Object.keys(options.query?.order || {}), options, context]));

  return {
    ...response,
    error,
    refetch: (options) => load(options, true),
  };
}
